module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dundun-bargain"
  }, [_c('xs-title', {
    attrs: {
      "h": _vm.exp.h,
      "m": _vm.exp.m,
      "s": _vm.exp.s
    }
  }), _vm._v(" "), _c('xs-list', {
    attrs: {
      "list": _vm.list
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b83c9a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/buy-limit/index.vue
// module id = 1560
// module chunks = 1